import { CardInfoDto } from "./card-info.dto";

export class CardTextDto{
    /*
    * 
    */
   constructor(
    public id?: number,
    public textDetail?: string,
    public locale?: string,
    public photo?: string,
    public cardInfo?: CardInfoDto
   ){}
}